import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js'
import CodeEditor from './code_editor.js'

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : ''
}

function cloneSnippet(snippet) {
  return {
    name: '',
    slug: '',
    usage: '',
    html_body: '',
    style_body: '',
    script_body: '',
    ...(snippet || {})
  }
}

export default Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    'code-editor': CodeEditor
  },

  props: {
    mode: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      snippet: cloneSnippet(this.formData.snippet)
    }
  },

  computed: {
    isNew() {
      return this.mode === 'new'
    },

    title() {
      return this.isNew ? '新建片段' : `修改${this.snippet.name}`
    },

    paths() {
      return this.formData.paths || {}
    },

    authenticityToken() {
      return csrfToken()
    },

    formAction() {
      return this.isNew ? this.paths.create : this.paths.update
    },

    slugHint() {
      return this.formData.slug_hint || ''
    }
  },

  template: `
    <settings-container active-tab="templates">
      <template slot="content">
        <div class="templates-settings template-form-page snippets-form-page">
          <div class="template-form-header">
            <div>
              <div class="templates-kicker">模板设置</div>
              <h1>{{ title }}</h1>
              <p>维护可在模板中通过 include 引用的 HTML、样式和脚本片段。</p>
            </div>
            <a :href="paths.index" class="btn btn-default btn-small outlined">返回片段列表</a>
          </div>

          <div class="template-form-card">
            <form :action="formAction" method="post" class="template-form snippets-form">
              <input type="hidden" name="authenticity_token" :value="authenticityToken" />
              <input v-if="!isNew" type="hidden" name="_method" value="patch" />

              <div class="template-meta-fields snippets-meta-fields">
                <div class="form-row">
                  <label>名称</label>
                  <input class="controlled-input" name="snippet[name]" v-model="snippet.name" required />
                </div>

                <div class="form-row">
                  <label>Slug</label>
                  <input class="controlled-input" name="snippet[slug]" v-model="snippet.slug" required />
                  <p class="snippet-field-hint">{{ slugHint }}</p>
                </div>
              </div>

              <div class="template-editor-grid">
                <code-editor label="用法说明"
                             name="snippet[usage]"
                             mode="text/html"
                             v-model="snippet.usage" />
                <code-editor label="HTML"
                             name="snippet[html_body]"
                             mode="text/html"
                             v-model="snippet.html_body" />
                <code-editor label="SCSS"
                             name="snippet[style_body]"
                             mode="text/css"
                             v-model="snippet.style_body" />
                <code-editor label="JavaScript"
                             name="snippet[script_body]"
                             mode="text/javascript"
                             v-model="snippet.script_body" />
              </div>

              <div class="template-form-actions">
                <a :href="paths.index" class="btn btn-default outlined">取消</a>
                <button type="submit" class="btn btn-success">
                  {{ isNew ? '新建' : '更新' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </template>
    </settings-container>
  `
})
